import { Avatar, Link, Skeleton, Stack, TableCell, TableRow, Typography } from "@mui/material"
import { useQuery } from "@tanstack/react-query"
import React from "react"

import { Agent } from "../../api/old-agents-api"
import { OrderType } from "@/api/agents-api"
import { getVolumeByAgentType } from "@/api/agents-stats-api"
import { getTotalOrders } from "@/api/messages-api"
import { getAggregatedStats } from "@/api/portfolio-agents-api"
import { PortfolioAgentIcon } from "@/components/PortfolioAgentIcon"
import { UsdAmountBlock } from "@/components/UsdAmountBlock"

type AgentsTableRowProps = {
  row: Agent
}

export function AgentsTableRow(props: AgentsTableRowProps) {
  const { row } = props

  const { data: orders } = useQuery({
    queryKey: ["agent-spawns", row.factory, row.spawnMethod],
    enabled: !!row.spawnMethod && !!row.factory,
    queryFn: () => getTotalOrders(1, "", false, row.factory as string, row.spawnMethod as string),
  })

  const { data: volume } = useQuery({
    queryKey: ["agent-volume", row.factory, row.spawnMethod],
    enabled: !!row.agentType,
    queryFn: () => getVolumeByAgentType(row.agentType as OrderType),
  })

  const { data: portfolioAgentStats } = useQuery({
    queryKey: ["portfolio-agents-stats", row.name],
    enabled: !row.spawnMethod,
    queryFn: getAggregatedStats,
  })

  const spawns = row.spawnMethod ? orders?.[0] : portfolioAgentStats?.agentCount
  const volumeUSD = row.spawnMethod ? volume : portfolioAgentStats?.totalVolume

  return (
    <TableRow>
      <TableCell variant="text">
        <Stack
          direction="row"
          gap={2}
          alignItems="center"
          component={row.link ? Link : "div"}
          href={row.link}
          target="_blank"
          rel="noreferrer"
          underline="always"
        >
          {row.logo ? (
            <Avatar
              src={row.logo}
              alt={row.name || " "}
              sx={{ width: 18, height: 18, fontSize: "0.875rem" }}
            />
          ) : (
            <PortfolioAgentIcon height={18} width={20} />
          )}
          <Typography variant="inherit" color={!row.name ? "text.secondary" : "text.primary"}>
            {row.name || "Unknown"}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell variant="number">
        {typeof volumeUSD !== "undefined" ? (
          <UsdAmountBlock amount={volumeUSD} />
        ) : (
          <Skeleton width={60} />
        )}
      </TableCell>
      <TableCell variant="number">
        {spawns !== undefined ? spawns : <Skeleton width={60} />}
      </TableCell>
      {/* <TableCell variant="number">
        <Typography variant="inherit" color="text.primary">
          {row.version}
        </Typography>
      </TableCell> */}
      {/* {row.spawnMethod ? (
        <TableCell variant="number">
          {releaseAt ? formatDate(releaseAt) : <Skeleton width={60} />}
        </TableCell>
      ) : (
        <TableCell variant="number">-</TableCell>
      )} */}
      <TableCell variant="text">
        <Typography variant="inherit" color="text.primary">
          <Link href={row.developerLink} target="_blank" rel="noreferrer" underline="always">
            {row.developer}
          </Link>
        </Typography>
      </TableCell>
    </TableRow>
  )
}
